export const ACCOUNT_MANAGEMENT_TYPES = {
  APP_WIDE: 'app_wide',
  CHECKOUT_ONLY: 'checkout_only',
};

// QH specific features
export const SIMPLICITY_HEADER_ENABLED = true;
export const CLASSIC_OFFERS_ENABLED = true;
export const POINTS_EARN_ENABLED = true;
export const DEPOSIT_PAY_ENABLED = true;
export const PAYWITH_TOGGLE_ENABLED = true;
export const CAMPAIGN_BANNER_ENABLED = true;
export const SELF_SERVICE_ENABLED = true;
export const PERSONALISE_TRACKING_ENABLED = true;
export const WELCOME_MESSAGE_ENABLED = true;
export const QFF_ACCOUNT_MANAGEMENT = ACCOUNT_MANAGEMENT_TYPES.APP_WIDE;
export const FLIGHT_BOOKER_MESSAGE_ENABLED = true;
export const OAUTH_ENABLED = true;
export const EXCLUSIVE_OFFERS_ENABLED = true;
export const POINTS_REDEMPTION_ENABLED = true;
export const QTA_ENABLED = true;
export const CTA_ENABLED = false;
export const CAMPAIGNS_ENABLED = true;
export const TRAVEL_INSURANCE_CROSS_SELL_ENABLED = true;
